// The eBay inquiry/case History in the AI Suggestion panel (2026-10-23).
// The server records each reply CXHub sends on the inquiry into the History
// (source 'cxhub', sentBy the agent or 'system:automation') and re-reads the
// inquiry from eBay when the contact is opened
// (server/src/services/ebay-case-history.js).

export const CXHUB_SOURCE = 'cxhub'
export const AUTOMATION_SENDER = 'system:automation'

// Whether the History belongs to an eBay inquiry the server can re-read:
// the INR request, a case resolved through the inquiry API, or a reply CXHub
// recorded with its inquiry id. Mirrors historyInquiryId() on the server.
export function hasRefreshableCaseHistory(suggestion) {
  if (!suggestion?.id) return false
  if (suggestion.inrRequestId) return true
  if (suggestion.caseId && suggestion.caseKind === 'inquiry') return true
  const history = Array.isArray(suggestion.modelMeta?.inrHistory) ? suggestion.modelMeta.inrHistory : []
  return history.some((h) => h?.source === CXHUB_SOURCE && h?.inquiryId)
}

// The marker under a History entry CXHub sent, or null for eBay's own entries.
export function caseHistorySentLabel(entry) {
  if (entry?.source !== CXHUB_SOURCE) return null
  const by = entry.sentBy && entry.sentBy !== AUTOMATION_SENDER ? entry.sentBy : 'automation'
  return `Sent from CXHub by ${by}`
}

// The suggestion with its History replaced by a refreshed one; the same
// object when the refresh is for another suggestion or brought nothing.
export function withRefreshedCaseHistory(suggestion, suggestionId, history) {
  if (!suggestion || suggestion.id !== suggestionId || !Array.isArray(history)) return suggestion
  const current = suggestion.modelMeta?.inrHistory ?? null
  if (JSON.stringify(current) === JSON.stringify(history)) return suggestion
  return { ...suggestion, modelMeta: { ...(suggestion.modelMeta ?? {}), inrHistory: history } }
}

// The translated History lines are index-aligned with the History as it was
// when they were translated. Shown only while the lengths still match, so a
// refresh that added an entry never puts a translation beside the wrong one.
export function alignedHistoryTranslation(history, translation) {
  if (!Array.isArray(translation) || !Array.isArray(history)) return null
  return translation.length === history.length ? translation : null
}
